import React from 'react';
import headerImageLight from '../../assets/images/logo_light.png';
import headerImageDark from '../../assets/images/logo_dark.png';
import Toggle from '../Toggle/Toggle';

import styles from './Header.module.scss';

function Header({ isLight, theme, toggleTheme }) {
  return (
    <section className={styles.header}>
      <Toggle theme={theme} toggleTheme={toggleTheme} />
      <img
        className={styles.headerImage}
        src={isLight ? headerImageLight : headerImageDark}
        alt="computer screen with html tag"
      />
    </section>
  );
}

export default Header;
